import React from 'react';
import AIEnhancedSafetyGenerator from './AIEnhancedSafetyGenerator';
import { Card, CardContent } from './ui/card';
import { Brain, Camera, FileText, ClipboardCheck, ArrowRight, Sparkles } from 'lucide-react';

const AIEnhancedSafetyPage = () => {
  return (
    <div className="min-h-screen bg-slate-50 p-4 md:p-6" data-testid="ai-enhanced-safety-page">
      {/* Header */}
      <div className="mb-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 bg-gradient-to-br from-purple-100 to-blue-100 rounded-lg">
            <Sparkles className="w-8 h-8 text-purple-600" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-slate-900">AI-Enhanced Safety Documents</h1>
            <p className="text-slate-500">Generate comprehensive JHAs and PTPs using AI photo analysis</p>
          </div>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <Card className="bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200">
            <CardContent className="py-4">
              <div className="flex items-start gap-3">
                <Camera className="w-8 h-8 text-blue-600" />
                <div>
                  <h3 className="font-semibold text-slate-900">Photo Analysis</h3>
                  <p className="text-sm text-slate-600">Upload worksite photos for AI hazard detection</p>
                </div>
              </div>
            </CardContent>
          </Card>
          
          <Card className="bg-gradient-to-br from-purple-50 to-purple-100 border-purple-200">
            <CardContent className="py-4">
              <div className="flex items-start gap-3">
                <Brain className="w-8 h-8 text-purple-600" />
                <div>
                  <h3 className="font-semibold text-slate-900">Smart Analysis</h3>
                  <p className="text-sm text-slate-600">AI identifies hazards, controls, and PPE requirements</p>
                </div>
              </div>
            </CardContent>
          </Card>
          
          <Card className="bg-gradient-to-br from-green-50 to-green-100 border-green-200">
            <CardContent className="py-4">
              <div className="flex items-start gap-3">
                <FileText className="w-8 h-8 text-green-600" />
                <div>
                  <h3 className="font-semibold text-slate-900">Auto-Generate</h3>
                  <p className="text-sm text-slate-600">Creates complete JHA or PTP documents instantly</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* How It Works */}
        <Card className="mb-6 bg-slate-800 text-white">
          <CardContent className="py-4">
            <h3 className="font-semibold mb-3">How It Works</h3>
            <div className="flex flex-wrap items-center gap-2 text-sm">
              <div className="flex items-center gap-2 bg-white/10 px-3 py-2 rounded-lg">
                <Camera className="w-4 h-4 text-blue-400" />
                <span>Upload Photos</span>
              </div>
              <ArrowRight className="w-4 h-4 text-slate-500" />
              <div className="flex items-center gap-2 bg-white/10 px-3 py-2 rounded-lg">
                <FileText className="w-4 h-4 text-purple-400" />
                <span>Describe Work</span>
              </div>
              <ArrowRight className="w-4 h-4 text-slate-500" />
              <div className="flex items-center gap-2 bg-white/10 px-3 py-2 rounded-lg">
                <Brain className="w-4 h-4 text-amber-400" />
                <span>AI Analyzes</span>
              </div>
              <ArrowRight className="w-4 h-4 text-slate-500" />
              <div className="flex items-center gap-2 bg-white/10 px-3 py-2 rounded-lg">
                <ClipboardCheck className="w-4 h-4 text-green-400" />
                <span>Get JHA/PTP</span>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Main Generator */}
      <AIEnhancedSafetyGenerator documentType="jha" />
    </div>
  );
};

export default AIEnhancedSafetyPage;
